import { useMemo } from 'react'

import { mapDatesToSeriesLabels, TypeFormats } from 'utils/format'

import useFilters from './useFilters'

export interface DateRange {
  startDate: string
  endDate: string
  prevStartDate: string
  prevEndDate: string
  legendText: ReturnType<typeof mapDatesToSeriesLabels>
  currentSeriesLabel: string
  prevSeriesLabel: string
}

const useDateRange = (): DateRange => {
  const { timePeriod } = useFilters()

  return useMemo<DateRange>(() => {
    const legendText = mapDatesToSeriesLabels(
      timePeriod.startDate,
      timePeriod.endDate,
      timePeriod.prevStart,
      timePeriod.prevEnd
    )
    return {
      startDate: TypeFormats.DATE(timePeriod.startDate),
      endDate: TypeFormats.DATE(timePeriod.endDate),
      prevStartDate: TypeFormats.DATE(timePeriod.prevStart),
      prevEndDate: TypeFormats.DATE(timePeriod.prevEnd),
      legendText,
      currentSeriesLabel: legendText.series,
      prevSeriesLabel: legendText.previousSeries,
    }
  }, [timePeriod])
}

export default useDateRange
